/* eslint-disable no-param-reassign */

/* Liefert den Scrollabstand zur übergebenen Seite des Tabellenrahmens */
function getScrollPosition(innerWrapper, side) {
  switch (side) {
    case 'left':
      return innerWrapper.scrollLeft;
    case 'right':
      return (
        innerWrapper.querySelector('table').clientWidth -
        innerWrapper.clientWidth -
        innerWrapper.scrollLeft
      );
    default:
      return false;
  }
}

/* Setzt die Transparenz der Schatten */
function setScrollOpacity(shadowElem, scrollPosition) {
  const shadowElemWidth = shadowElem.clientWidth;

  /* Der Schatten wird nur sichtbar, wenn ein Scrollabstand zur jeweiligen Seite vorhanden ist */
  if (scrollPosition / shadowElemWidth <= 0) {
    shadowElem.style.opacity = 0;
  } else if (scrollPosition <= shadowElemWidth) {
    const opacity = scrollPosition / shadowElemWidth;
    shadowElem.style.opacity = opacity;
  } else if (shadowElem.style.opacity !== 1) {
    shadowElem.style.opacity = 1;
  }
}

function updateScrollInfo(shadowLeft, shadowRight, innerWrapper) {
  const tableScrollLeft = getScrollPosition(innerWrapper, 'left');
  const tableScrollRight = getScrollPosition(innerWrapper, 'right');
  setScrollOpacity(shadowLeft, tableScrollLeft);
  setScrollOpacity(shadowRight, tableScrollRight);
}

export default function addScrollShadows() {
  const arrayOfWrappers = Array.from(
    document.getElementsByClassName('table-wrapper')
  );
  arrayOfWrappers.forEach((item) => {
    const wrapper = item;
    const innerWrapper = wrapper.querySelector('.table-inner-wrapper');
    const shadowLeft = wrapper.querySelector('.shadow-left');
    const shadowRight = wrapper.querySelector('.shadow-right');
    const tableScrollLeft = getScrollPosition(innerWrapper, 'left');
    const tableScrollRight = getScrollPosition(innerWrapper, 'right');

    /* Setzt die initiale Transparenz der Schatten */
    setScrollOpacity(shadowLeft, tableScrollLeft);
    setScrollOpacity(shadowRight, tableScrollRight);

    /* Setzt die Transparenz wärend des Scrollens passend zur Position */
    innerWrapper.addEventListener('scroll', () => {
      updateScrollInfo(shadowLeft, shadowRight, innerWrapper);
      shadowLeft.style.left = `${
        innerWrapper.querySelector('td').clientWidth
      }px`;
    });
  });
}
